/**
 * CommandInput - Input field with type detection and autocomplete
 */

import React, { useRef, useEffect } from 'react';
import { Search, Command, Loader2 } from 'lucide-react';

const CommandInput = ({
  value,
  onChange,
  onSubmit,
  inputType,
  loading,
  shortcutKey,
}) => {
  const inputRef = useRef(null);

  // Focus input on mount
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      onSubmit();
    }
  };

  const getTypeLabel = () => {
    switch (inputType) {
      case 'command':
        return 'Command';
      case 'query':
        return 'Query';
      default:
        return 'Search';
    }
  };

  return (
    <div className="command-bar-input-wrapper">
      <div className="command-bar-input-icon">
        {loading ? (
          <Loader2 size={20} className="spinning" />
        ) : inputType === 'command' ? (
          <Command size={20} />
        ) : (
          <Search size={20} />
        )}
      </div>

      <input
        ref={inputRef}
        type="text"
        className="command-bar-input"
        placeholder="Type a command or search..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        autoCorrect="off"
        autoCapitalize="off"
        spellCheck="false"
      />

      {value && (
        <span className="command-bar-type-indicator">
          {getTypeLabel()}
        </span>
      )}

      {!value && (
        <span className="command-bar-input-shortcut">{shortcutKey}</span>
      )}
    </div>
  );
};

export default CommandInput;
